import React from "react";
import { UserAvatarSkeleton } from "./UserAvatarSkeleton";
import { SkeletonTextGroup } from "./SkeletonTextGroup";
import { AvatarSize } from "@/common/avatar.common";
import { 
  SkeletonSize, 
  SkeletonWidth, 
  SkeletonGap, 
  SkeletonAlign, 
  SKELETON_GAP_CLASSES, 
  SKELETON_ALIGN_CLASSES 
} from "@/common/skeleton.common";
import { cn } from "@/lib/utils";

interface TextLine {
  size?: SkeletonSize;
  width?: SkeletonWidth;
}

interface AvatarWithTextSkeletonProps {
  avatarSize?: AvatarSize;
  textLines: TextLine[];
  gap?: SkeletonGap;
  align?: SkeletonAlign;
  className?: string;
  withAvatar?: boolean;
}

export const AvatarWithTextSkeleton = React.memo<AvatarWithTextSkeletonProps>(({
  avatarSize = "md",
  textLines,
  gap = "md",
  align = "center",
  withAvatar = true,
  className,
}) => {
  const gapClass = SKELETON_GAP_CLASSES[gap];
  const alignClass = SKELETON_ALIGN_CLASSES[align];

  return (
    <div className={cn("flex", alignClass, gapClass, className)} aria-hidden="true">
      {withAvatar && <UserAvatarSkeleton size={avatarSize} className="flex-shrink-0" />}
      <SkeletonTextGroup lines={textLines} />
    </div>
  );
});

AvatarWithTextSkeleton.displayName = "AvatarWithTextSkeleton"; 